import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { MoradorComRendaDto } from '@usucampeao/lib-reurb-simplificado';
import { BaseComponent, LoadingService, NavigationService, ToastService } from '@usucampeao/ui-mobile';
import { Observable } from 'rxjs';
import { finalize, first, takeUntil, tap } from 'rxjs/operators';
import { CadastrosQuery } from '../../../state/cadastros.query';
import { CadastroService } from '../../../state/cadastros.service';

@Component({
  templateUrl: './listagem-moradores-com-renda.page.html',
  styleUrls: ['./listagem-moradores-com-renda.page.scss']
})
export class ListagemMoradoresComRendaPage extends BaseComponent implements OnInit {
  public cadastroId: string;
  public superSocialAceito = false;
  public moradoresComRenda$: Observable<MoradorComRendaDto[]>;

  constructor(
    private readonly alertCtrl: AlertController,
    private readonly cadastrosService: CadastroService,
    private readonly cadastrosQuery: CadastrosQuery,
    private readonly loadingService: LoadingService,
    private readonly navigationService: NavigationService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly toastService: ToastService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.route.params
      .pipe(
        tap(params => this.cadastroId = params.cadastroId),
        tap(() => this.moradoresComRenda$ = this.cadastrosQuery.buscarMoradoresComRenda(this.cadastroId)),
        tap(() => this.listarMoradoresComRenda()),
        takeUntil(this.ngUnsubscribe$)
      )
      .subscribe()
  }

  private listarMoradoresComRenda(): void {
    this.loadingService.createLoader();
    this.cadastrosService.listarMoradoresComRenda(this.cadastroId)
      .pipe(
        finalize(() => this.loadingService.dismiss()),
      )
      .subscribe({
        error: error => {
          this.toastService.error('Erro ao listar moradores. Por favor tente novamente mais tarde.');
          throw error;
        }
      })
  }

  public adicionarNovoMoradorComRenda(): void {
    this.router.navigate(['../moradores-com-renda/adicionar'], { relativeTo: this.route });
  }

  public confirmarMoradores(): void {
    this.cadastrosQuery.selectEntity(this.cadastroId)
      .pipe(
        first()
      )
      .subscribe(cadastro => {
        let route = '../comprovante-renda/selecionar-tipo-assinatura';
        if (cadastro.comprovanteRendaDataAssinatura) {
          route = '../confirmar-informacoes';
        }
        this.router.navigate([route], { relativeTo: this.route })
      });
  }

  public async cancelarProgramaSuperSocial() {
    const alert = await this.alertCtrl.create({
      header: 'Cancelar programa',
      message: 'Tem certeza que deseja cancelar o programa?',
      buttons: [
        {
          text: 'Não cancelar participação',
          role: 'cancel',
        },
        {
          text: 'Cancelar participação',
          cssClass: 'alert-button-danger',
          handler: async () => {
            await this.loadingService.createLoader();
            this.cadastrosService.cancelarProgramaSuperSocial(this.cadastroId)
              .pipe(
                finalize(() => this.loadingService.dismiss()),
              )
              .subscribe({
                next: () => {
                  this.toastService.success('Programa cancelado com sucesso.').toPromise();
                  this.router.navigate(['../selecionar-forma-pagamento'], { relativeTo: this.route });
                },
                error: error => {
                  this.toastService.error('Erro ao cancelar programa. Por favor tente novamente mais tarde.').toPromise();
                  throw error;
                }
              })
          }
        }
      ]
    });

    await alert.present();
  }

  public voltar(): void {
    this.navigationService.voltar();
  }
}
